import { useState } from "react";
import {
  DatePicker,
  Select,
  InputNumber,
  Button,
  Image,
  Form,
  Typography,
  Flex,
  Input,
} from "antd";
import dayjs from "dayjs";
import "antd/dist/reset.css"; // reset antd styles
import visaSearchBg from "../assets/images/holidayBanner.jpg";
import PriceRangeDropdown from "./PriceRangeDropdown.jsx";
import RoomsGuestsDropdown from "./RoomsGuestsDropdown.jsx";
import CustomDateRange from "./CustomDateRange.jsx";
import sliderImg from "../assets/images/bannerHotel.jpg";
import TravelMonthSelector from "./TravelMonthSelector.jsx";
import TravelMonthDropdown from "./TravelMonthSelector.jsx";
import { useNavigate } from "react-router-dom";
 
const { Search } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text, Paragraph } = Typography;

export default function HolidaySearch() {
  const [formData, setFormData] = useState({
    country: "UAE",
    city: "Dubai",
    checkIn: dayjs("2025-08-10"),
    checkOut: dayjs("2025-08-11"),
    rooms: 1,
    guests: 2,
    price: [2500, 5000],
  });
 const navigate = useNavigate();
  return (
    <div className="relative bg-cover bg-center flex items-center justify-center">
      <Image
        src={visaSearchBg}
        alt="Slide 1"
        className="w-full !h-full object-cover"
        preview={false}
      />

      <div className="container absolute z-10">
        <div class="relative w-[60%] m-auto text-center">
          {/* <!-- Stroke Layer --> */}
          <span class="absolute inset-0 text-[60px] leading-[73px] tracking-[6px] font-bold font-montserrat stroke-text z-0">
            Holidays That Stay With You Forever
          </span>

          {/* <!-- Gradient Fill Layer --> */}
          <span class="relative text-[60px] leading-[73px] tracking-[6px] font-bold font-montserrat gradient-text z-10">
            Holidays That Stay With You Forever
          </span>
        </div>

        <Paragraph className="text-2xl font-medium mt-4 text-center">
          Where Every Day Feels Like a Holiday.
        </Paragraph>

        <Flex gap={30} justify="center">
          <Search
            placeholder="Select Country"
            allowClear
            onSearch={(value) => console.log(value)}
            className="SearchInput !w-auto  my-8"
            onClick={() => navigate('/holiday-list')} 
          />
          <Search
            placeholder="Select City"
            allowClear
            onSearch={(value) => console.log(value)}
            className="SearchInput !w-auto my-8"
            onClick={() => navigate('/holiday-list')} 
          />
        </Flex>

        
      </div>
    </div>
  );
}
